import { render, staticRenderFns } from "./warehousing.vue?vue&type=template&id=91e0c128&scoped=true"
import script from "./warehousing.vue?vue&type=script&lang=js"
export * from "./warehousing.vue?vue&type=script&lang=js"
import style0 from "./warehousing.vue?vue&type=style&index=0&id=91e0c128&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e0c128",
  null
  
)

export default component.exports